/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import Button from "components/generals/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { FC, useState } from "react";
import Box from "./Box";
import { useTranslation } from "react-i18next";

/**
 * Props for InputFileUpload component.
 * @interface AcceptedFiles
 * @property {string} accept - File types accepted (MIME types)
 * @property {(file: File | null) => void} [setImage] - Callback with selected file
 * @property {boolean} [addNewImage] - Flag to add new image
 */
interface AcceptedFiles {
  accept: string;
  setImage?: (file: File | null) => void;
  addNewImage?: boolean;
}

/**
 * File upload button with file type filtering.
 * 
 * Features:
 * - Cloud upload icon
 * - File type filtering via accept prop
 * - Selected filename display
 * - Localized button text
 * - Hidden file input
 * - Info color variant
 * 
 * @param accept - MIME types accepted (e.g., "image/*", ".pdf")
 * @param setImage - Handler receiving selected File object
 * @param addNewImage - Flag for new image mode
 * @returns Upload button with file selection
 */
const InputFileUpload: FC<AcceptedFiles> = ({ accept, setImage, addNewImage }) => {
  const [selectedFile, setSelectedFile] = useState<string>();
  const { t } = useTranslation();
  const handleSelectImage = (files: FileList) => {
    if (files && files[0]) {
      setSelectedFile(files[0].name);
      if (addNewImage !== undefined) {
        setImage(files[0]);
      }
    }
  };

  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      color="info"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
    >
      {t("personForm.upload")}
      <input
        className="visually-hidden-input"
        type="file"
        accept={accept}
        onChange={(event) => handleSelectImage(event.target.files)}
      />
      <Box pl={1}>{selectedFile}</Box>
    </Button>
  );
};

export default InputFileUpload;
